export default "__VITE_ASSET__BqFFAXVe__"